import type React from 'react';
import styled from 'styled-components';
import { media } from 'src/components/base';
import ViewportContext from './context';

type StyledComponentProps = {
  mobile?: boolean;
  tablet?: boolean;
  desktop?: boolean;
  'data-test'?: string;
  'data-test-mobile'?: boolean;
  'data-test-desktop'?: boolean;
  'data-test-tablet'?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
};

const StyledViewport = styled.div.attrs<StyledComponentProps>(
  // TODO: Remove all this?
  ({ mobile, tablet, desktop }) => ({
    'data-test': 'Viewport',
    'data-test-mobile': mobile,
    'data-test-tablet': tablet,
    'data-test-desktop': desktop,
  })
)<StyledComponentProps>`
  /* Hide element with slightly increased specificity. This allows us to extend this component
    with custom display values and other styles rather than having to use it as a wrapper. */
  && {
    ${props => !props.mobile && media.smallOnly`display: none;`}
    ${props => !props.tablet && media.mediumOnly`display: none;`}
    ${props => !props.desktop && media.largeUp`display: none;`}
  }
`;

export { ViewportContext };

export default StyledViewport;
